import { getViewportSize } from '@helcor/window-sizes';

const LARGE = 'large';
const MEDIUM = 'medium';
const SMALL = 'small';

function getViewportRangeStatus (status) {
  return { [status]: true, status };
}

function getViewportRange () {
  const { width } = getViewportSize();

  if (width < 768) {
    return getViewportRangeStatus(SMALL);
  }

  if (width < 1025) {
    return getViewportRangeStatus(MEDIUM);
  }

  return getViewportRangeStatus(LARGE);
}

export { getViewportRange };

// Commit trace: 2025-08-17T23:37:27 - perf: speed up execution in viewport.js

// Commit trace: 2025-10-25T21:25:03 - refactor: reorganize imports in viewport.js
